<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oxe0Zn/media/FC-9781035814626.jpg?1721600811894" alt="This image is the cover for the book Don't Worry, He Doesn't Bite"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Worry, He Doesn't Bite
      </h1>
      <p class="bookDescription body article font2">
        <p>The vets on TV are always depicted as perfect clinicians, with sunshine and rainbows bursting out from their individual patients. But what media companies fail to show you are the more ‘uncommon’ cases, like a dog eating some used condoms, for example. This book aims to rectify this perception, specifically taking the reader on a journey through what life is like graduating as a veterinary surgeon. You will read about some pretty stupid cases my colleagues and I have experienced, all of which are true, though I must admit, I do have a habit of not letting the truth get in the way of a good story. So, sit back, relax, and take a break from this mundane existence we call life, as I show you the world through the eyes of a newly graduated veterinary surgeon.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elliot Charles
      </h2>
      
      <p class="authorDescription body article">Elliot Charles is a practising veterinary surgeon currently residing in the area of Manchester, but he originally grew up in South London. When he isn’t busy at work, he thoroughly enjoys broadening his interests in all things history, as well as keeping up to date with his beloved Arsenal football club. He also has a passion for food, both cooking and consuming, and in the evenings he can usually be found trying out new recipes in the kitchen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d0bd78c